// extracted by mini-css-extract-plugin
module.exports = {"cardColumn":"Combination_cardColumn__29jFS","leftSection":"Combination_leftSection__21gfP","switchHeaderButton":"Combination_switchHeaderButton__34Hq_"};